import { Stat } from "../utils/Stat";
import { AnimatorControllerLayer2D } from "./AnimatorControllerLayer2D";
import { Component } from "./Component";
import { ClassUtils } from "../utils/ClassUtils";
import { AniParmType } from "./AnimatorControllerParse";
import { AnimatorUpdateMode } from "./AnimatorUpdateMode";
import { Loader } from "../net/Loader";
import { ILaya } from "../../ILaya";
import { SpriteConst } from "../display/SpriteConst";
export class Animator2D extends Component {
    constructor() {
        super();
        this._speed = 1;
        this._updateMode = AnimatorUpdateMode.Normal;
        this._lowUpdateDelty = 20;
        this._isPlaying = true;
        this._isPlayBack = false;
        this._controllerLayers = [];
        this._parameters = {};
    }
    get controller() {
        return this._controller;
    }
    set controller(val) {
        if (this._controller)
            this._controller._removeReference();
        this._controller = val;
        if (val) {
            val._addReference();
            val.updateTo(this);
        }
    }
    get parameters() {
        return this._parameters;
    }
    set parameters(val) {
        this._parameters = val;
    }
    get speed() {
        return this._speed;
    }
    set speed(num) {
        this._speed = num;
    }
    get isPlaying() {
        return this._isPlaying;
    }
    _updateStateFinish(animatorState, playState) {
        if (playState._finish) {
            if (this.owner._renderType & SpriteConst.GRAPHICS) {
                this.owner.graphics.repaint();
            }
            animatorState._eventExit();
        }
    }
    _switchState(parentState, currentState) {
        if (parentState) {
            parentState._eventSwitch(currentState);
        }
    }
    _setClipDatasToNode(stateInfo, additive, weight, controllerLayer = null) {
        var realtimeDatas = stateInfo._realtimeDatas;
        var nodes = stateInfo._clip._nodes;
        for (var i = 0, n = nodes.count; i < n; i++) {
            if (null == realtimeDatas[i])
                continue;
            var node = nodes.getNodeByIndex(i);
            var o = this.getOwner(node);
            o && this._applyFloat(o, additive, weight, realtimeDatas[i]);
        }
    }
    _applyFloat(o, additive, weight, data) {
        var pro = o.pro;
        if (pro && pro.ower) {
            if (additive && "number" === typeof data) {
                pro.ower[pro.key] = pro.defVal + weight * data;
            }
            else if ("number" === typeof data) {
                pro.ower[pro.key] = weight * data;
            }
            else {
                if ("string" === typeof data) {
                    if (data.startsWith("tres://")) {
                        let url = data.replace("tres://", "");
                        let source = Loader.getRes(url, Loader.IMAGE);
                        if (source) {
                            data = source;
                        }
                        else {
                            ILaya.loader.load(url, { type: Loader.IMAGE }).then(tex => {
                                if (!this.destroyed) {
                                    pro.ower[pro.key] = tex;
                                }
                            });
                            return;
                        }
                    }
                }
                pro.ower[pro.key] = data;
            }
        }
    }
    getOwner(node) {
        var ret;
        if (this._ownerMap) {
            ret = this._ownerMap.get(node);
            if (ret) {
                return ret;
            }
        }
        var property = this.owner;
        for (var j = 0, m = node.ownerPathCount; j < m; j++) {
            var ownPat = node.getOwnerPathByIndex(j);
            if ("" == ownPat) {
                continue;
            }
            else {
                property = property.getChild(ownPat);
                if (!property)
                    break;
            }
        }
        ret = { ower: property };
        if (property) {
            var pobj = property;
            var propertyCount = node.propertyCount;
            if (1 == propertyCount) {
                var pname = node.getPropertyByIndex(0);
                ret.pro = { ower: property, key: pname, defVal: property[pname] };
            }
            else {
                for (var i = 0; i < propertyCount; i++) {
                    var pname = node.getPropertyByIndex(i);
                    if (i == propertyCount - 1 || null == pobj) {
                        ret.pro = { ower: pobj, key: pname, defVal: pobj ? pobj[pname] : null };
                        break;
                    }
                    if ('_gcmds' === pname && null == pobj[pname] && pobj.graphics) {
                        pobj = pobj.graphics;
                        pname = "cmds";
                    }
                    if (null == pobj[pname] && property == pobj) {
                        pobj = null;
                        var classObj = ClassUtils.getClass(pname);
                        if (classObj) {
                            pobj = property.getComponent(classObj);
                        }
                    }
                    else {
                        pobj = pobj[pname];
                    }
                }
            }
        }
        if (null == this._ownerMap) {
            this._ownerMap = new Map();
        }
        this._ownerMap.set(node, ret);
        return ret;
    }
    _updateClipDatas(animatorState, addtive, playStateInfo) {
        var clip = animatorState._clip;
        var clipDuration = clip._duration;
        var curPlayTime = animatorState.clipStart * clipDuration + playStateInfo._normalizedPlayTime * playStateInfo._duration;
        var currentFrameIndices = animatorState._currentFrameIndices;
        let frontPlay = playStateInfo._frontPlay;
        clip._evaluateClipDatasRealTime(curPlayTime, currentFrameIndices, addtive, frontPlay, animatorState._realtimeDatas);
    }
    _updatePlayer(animatorState, playState, elapsedTime, loop, layerIndex) {
        playState._playAllTime += Math.abs(elapsedTime);
        const clipDuration = animatorState.clipEnd - animatorState.clipStart;
        var clipDurationTime = animatorState._clip._duration * clipDuration;
        var lastElapsedTime = playState._elapsedTime;
        var elapsedPlaybackTime = lastElapsedTime + elapsedTime;
        playState._lastElapsedTime = lastElapsedTime;
        playState._elapsedTime = elapsedPlaybackTime;
        var normalizedTime = elapsedPlaybackTime / clipDurationTime;
        var playTime = normalizedTime % 1.0;
        const normalizedPlayTime = playTime < 0 ? playTime + 1.0 : playTime;
        playState._normalizedPlayTime = normalizedPlayTime;
        playState._duration = clipDurationTime;
        let parentPlayNum = Math.floor(Math.abs(lastElapsedTime) / clipDurationTime);
        let playNum = Math.floor(Math.abs(elapsedPlaybackTime) / clipDurationTime);
        if (animatorState.yoyo) {
            this._isPlayBack = 0 != Math.floor(playNum) % 2;
            if (this._isPlayBack) {
                playState._normalizedPlayTime = 1 - playState._normalizedPlayTime;
            }
            parentPlayNum = Math.floor(parentPlayNum / 2);
            playNum = Math.floor(playNum / 2);
        }
        if (0 < loop && loop <= playNum) {
            playState._finish = true;
            if (animatorState.yoyo) {
                playState._normalizedPlayTime = 0;
            }
            else {
                playState._normalizedPlayTime = 1;
            }
        }
        const isReplay = parentPlayNum != playNum;
        if (isReplay) {
            animatorState._eventLoop();
        }
        animatorState._eventStateUpdate(playState._normalizedPlayTime);
        this._applyTransition(layerIndex, animatorState._eventtransition(normalizedPlayTime, this.parameters, isReplay));
    }
    _updateEventScript(stateInfo, playStateInfo) {
        let clip = stateInfo._clip;
        let events = clip._animationEvents;
        if (!events || 0 == events.length)
            return;
        let clipDuration = clip._duration;
        var curPlayTime = playStateInfo.animatorState.clipStart * clipDuration + playStateInfo._normalizedPlayTime * playStateInfo._duration;
        let frontPlay = playStateInfo._frontPlay;
        const speed = playStateInfo._currentState.speed;
        if (0 > speed)
            frontPlay = !frontPlay;
        if (this._isPlayBack) {
            frontPlay = !frontPlay;
        }
        let pTime = playStateInfo._parentPlayTime;
        let parentPlayTime = playStateInfo._parentPlayTime;
        if (null == parentPlayTime) {
            if (frontPlay) {
                parentPlayTime = clipDuration * playStateInfo.animatorState.clipStart;
            }
            else {
                parentPlayTime = clipDuration * playStateInfo.animatorState.clipEnd;
            }
        }
        if (frontPlay) {
            if (curPlayTime < parentPlayTime) {
                const cpt = playStateInfo.animatorState.clipStart * clipDuration + playStateInfo._duration;
                this._eventScript(events, parentPlayTime, cpt, true);
                parentPlayTime = playStateInfo.animatorState.clipStart * clipDuration;
            }
        }
        else {
            if (curPlayTime > parentPlayTime) {
                const cpt = playStateInfo.animatorState.clipStart * clipDuration;
                this._eventScript(events, parentPlayTime, cpt, false);
                parentPlayTime = playStateInfo.animatorState.clipStart * clipDuration + playStateInfo._duration;
            }
        }
        this._eventScript(events, parentPlayTime, curPlayTime, frontPlay);
        if (pTime == playStateInfo._parentPlayTime) {
            playStateInfo._parentPlayTime = curPlayTime;
        }
    }
    _eventScript(events, parentPlayTime, currPlayTime, frontPlay) {
        let scripts = this.owner.components;
        if (frontPlay) {
            for (let i = 0, len = events.length; i < len; i++) {
                let e = events[i];
                if (e.time > parentPlayTime && e.time <= currPlayTime) {
                    for (let j = 0, m = scripts.length; j < m; j++) {
                        let script = scripts[j];
                        if (script._isScript()) {
                            let fun = script[e.eventName];
                            (fun) && (fun.apply(script, e.params));
                        }
                    }
                }
                else if (e.time > currPlayTime) {
                    break;
                }
            }
        }
        else {
            for (let i = events.length - 1; i >= 0; i--) {
                let e = events[i];
                if (e.time < parentPlayTime && e.time >= currPlayTime) {
                    for (let j = 0, m = scripts.length; j < m; j++) {
                        let script = scripts[j];
                        if (script._isScript()) {
                            let fun = script[e.eventName];
                            (fun) && (fun.apply(script, e.params));
                        }
                    }
                }
                else if (e.time < currPlayTime) {
                    break;
                }
            }
        }
    }
    _applyTransition(layerindex, transition) {
        if (!transition)
            return false;
        return this.crossFade(transition.destState.name, layerindex, transition.transstartoffset, transition.transduration);
    }
    _applyUpdateMode(delta) {
        let ret;
        switch (this._updateMode) {
            case AnimatorUpdateMode.Normal:
                ret = delta;
                break;
            case AnimatorUpdateMode.LowFrame:
                ret = (Stat.loopCount % this._lowUpdateDelty == 0) ? delta * this._lowUpdateDelty : 0;
                break;
            case AnimatorUpdateMode.UnScaleTime:
                ret = 0;
                break;
        }
        return ret;
    }
    gotoAndStopByFrame(name, layerIndex, frame) {
        var controllerLayer = this._controllerLayers[layerIndex];
        if (controllerLayer) {
            var animatorState = controllerLayer.getStateByName(name);
            if (!animatorState || !animatorState._clip)
                return;
            var allFrame = animatorState._clip._duration * animatorState._clip._frameRate;
            let normalizedTime = frame / allFrame;
            if (1 < normalizedTime)
                normalizedTime = 1;
            this.gotoAndStop(name, layerIndex, normalizedTime);
        }
    }
    getControllerLayer(layerIndex = 0) {
        return this._controllerLayers[layerIndex];
    }
    gotoAndStop(name, layerIndex, normalizedTime) {
        var controllerLayer = this._controllerLayers[layerIndex];
        if (controllerLayer) {
            var animatorState = controllerLayer.getStateByName(name);
            if (!animatorState || !animatorState._clip)
                return;
            var playStateInfo = controllerLayer._playStateInfo;
            var curPlayState = playStateInfo._currentState;
            var clipDuration = animatorState._clip._duration;
            var calclipduration = animatorState._clip._duration * (animatorState.clipEnd - animatorState.clipStart);
            playStateInfo._resetPlayState(clipDuration * normalizedTime, calclipduration);
            playStateInfo._normalizedPlayTime = normalizedTime;
            controllerLayer._playType = 0;
            if (curPlayState !== animatorState) {
                playStateInfo._currentState = animatorState;
                this._switchState(curPlayState, animatorState);
            }
            animatorState._eventStart(this, layerIndex);
            let addtive = controllerLayer.blendingMode != AnimatorControllerLayer2D.BLENDINGMODE_OVERRIDE;
            this._updateClipDatas(animatorState, addtive, playStateInfo);
            this._setClipDatasToNode(animatorState, addtive, controllerLayer.defaultWeight, controllerLayer);
            this.stop();
        }
    }
    play(name, layerIndex = 0, normalizedTime = Number.NEGATIVE_INFINITY) {
        if (this._checkEnterIndex) {
            let i = this._checkEnterIndex.indexOf(layerIndex);
            if (0 <= i) {
                this._checkEnterIndex.splice(i, 1);
            }
        }
        this._isPlaying = true;
        var controllerLayer = this._controllerLayers[layerIndex];
        if (controllerLayer) {
            var defaultState = controllerLayer.defaultState;
            if (!name && !defaultState)
                throw new Error("Animator:must have default clip value,please set clip property.");
            var playStateInfo = controllerLayer._playStateInfo;
            var curPlayState = playStateInfo._currentState;
            var animatorState = name ? controllerLayer.getStateByName(name) : defaultState;
            if (!animatorState._clip)
                return;
            var clipDuration = animatorState._clip._duration;
            var calclipduration = animatorState._clip._duration * (animatorState.clipEnd - animatorState.clipStart);
            if (curPlayState !== animatorState) {
                if (normalizedTime !== Number.NEGATIVE_INFINITY)
                    playStateInfo._resetPlayState(clipDuration * normalizedTime, calclipduration);
                else
                    playStateInfo._resetPlayState(0.0, calclipduration);
                (curPlayState !== null && curPlayState !== animatorState);
                controllerLayer._playType = 0;
                playStateInfo._currentState = animatorState;
            }
            else {
                if (normalizedTime !== Number.NEGATIVE_INFINITY) {
                    playStateInfo._resetPlayState(clipDuration * normalizedTime, calclipduration);
                    controllerLayer._playType = 0;
                }
                else {
                    playStateInfo._resetPlayState(clipDuration * animatorState.clipStart, calclipduration);
                }
            }
            this._switchState(curPlayState, animatorState);
            animatorState._eventStart(this, layerIndex);
        }
    }
    stop() {
        this._isPlaying = false;
    }
    onUpdate() {
        if (!this._isPlaying)
            return;
        if (this._checkEnterIndex) {
            for (let i = this._checkEnterIndex.length - 1; i >= 0; i--) {
                let index = this._checkEnterIndex[i];
                let enterTransition = this._controllerLayers[index]._enterTransition;
                if (enterTransition.check(0, this.parameters, true)) {
                    var defaultClip = this.getDefaultState(index);
                    this.play(null, index, defaultClip.cycleOffset);
                }
            }
        }
        var delta = this.owner.timer.delta / 1000.0;
        delta = this._applyUpdateMode(delta);
        if (0 == this.speed || 0 == delta) {
            for (var i = 0, n = this._controllerLayers.length; i < n; i++) {
                var controllerLayer = this._controllerLayers[i];
                if (!controllerLayer.enable)
                    continue;
                var playStateInfo = controllerLayer._playStateInfo;
                if (playStateInfo._finish && controllerLayer._playType == 0) {
                    var animatorState = playStateInfo._currentState;
                    this._applyTransition(i, animatorState._eventtransition(playStateInfo._normalizedPlayTime, this.parameters, false));
                }
            }
            return;
        }
        var needRender = true;
        for (var i = 0, n = this._controllerLayers.length; i < n; i++) {
            var controllerLayer = this._controllerLayers[i];
            if (!controllerLayer.enable)
                continue;
            var playStateInfo = controllerLayer._playStateInfo;
            var addtive = controllerLayer.blendingMode != AnimatorControllerLayer2D.BLENDINGMODE_OVERRIDE;
            switch (controllerLayer._playType) {
                case 0:
                    var animatorState = playStateInfo._currentState;
                    var speed = this._speed * animatorState.speed;
                    var finish = playStateInfo._finish;
                    var loop = animatorState.loop;
                    if (-1 >= loop) {
                        var clip = animatorState._clip;
                        if (clip.islooping) {
                            loop = 0;
                        }
                        else {
                            loop = 1;
                        }
                    }
                    let dir = 1;
                    if (!playStateInfo._frontPlay) {
                        dir = -1;
                    }
                    if (finish) {
                        this._applyTransition(i, animatorState._eventtransition(playStateInfo._normalizedPlayTime, this.parameters, false));
                    }
                    else {
                        this._updatePlayer(animatorState, playStateInfo, delta * speed * dir, loop, i);
                    }
                    playStateInfo = controllerLayer._playStateInfo;
                    animatorState = playStateInfo._currentState;
                    if (needRender) {
                        this._updateClipDatas(animatorState, addtive, playStateInfo);
                        if (!finish) {
                            this._setClipDatasToNode(animatorState, addtive, controllerLayer.defaultWeight, controllerLayer);
                            this._updateEventScript(animatorState, playStateInfo);
                        }
                    }
                    finish || this._updateStateFinish(animatorState, playStateInfo);
                    break;
            }
        }
    }
    addControllerLayer(controllerLayer) {
        this._controllerLayers.push(controllerLayer);
    }
    crossFade(name, layerIndex = 0, normalizedTime = Number.NEGATIVE_INFINITY, transitionDuration) {
        var controllerLayer = this._controllerLayers[layerIndex];
        if (controllerLayer) {
            var destAnimatorState = controllerLayer.getStateByName(name);
            if (destAnimatorState) {
                this.play(name, layerIndex, normalizedTime);
                return true;
            }
            else {
                console.warn("Invalid layerIndex " + layerIndex + ".");
            }
        }
        return false;
    }
    onAfterDeserialize() {
        let arr = this.controllerLayers;
        if (!arr || null != this.controller)
            return;
        delete this.controllerLayers;
        this._controllerLayers.length = 0;
        for (let layer of arr) {
            this.addControllerLayer(layer);
        }
    }
    onEnable() {
        if (this._checkEnterIndex)
            this._checkEnterIndex.length = 0;
        else
            this._checkEnterIndex = [];
        if (this._isPlaying) {
            for (var i = 0, n = this._controllerLayers.length; i < n; i++) {
                if (this._controllerLayers[i].playOnWake) {
                    var defaultClip = this.getDefaultState(i);
                    if (defaultClip) {
                        let enterTransition = this._controllerLayers[i]._enterTransition;
                        if (enterTransition) {
                            this._isPlaying = true;
                            if (enterTransition.check(0, this.parameters, true)) {
                                this.play(null, i, defaultClip.cycleOffset);
                            }
                            else {
                                this._checkEnterIndex.push(i);
                            }
                        }
                        else {
                            this.play(null, i, defaultClip.cycleOffset);
                        }
                    }
                }
            }
        }
    }
    getDefaultState(layerIndex = 0) {
        var controllerLayer = this._controllerLayers[layerIndex];
        return controllerLayer.defaultState;
    }
    setParamsTrigger(name) {
        const data = this._parameters[name];
        if (data && data.type === AniParmType.Trigger) {
            data.value = true;
        }
        else {
            this._parameters[name] = { name: name, type: AniParmType.Trigger, value: true };
        }
    }
    setParamsNumber(name, value) {
        const data = this._parameters[name];
        if (data && data.type === AniParmType.Float) {
            data.value = value;
        }
        else {
            this._parameters[name] = { name: name, type: AniParmType.Float, value: value };
        }
    }
    setParamsBool(name, value) {
        const data = this._parameters[name];
        if (data && data.type === AniParmType.Bool) {
            data.value = value;
        }
        else {
            this._parameters[name] = { name: name, type: AniParmType.Bool, value: value };
        }
    }
    getParamsvalue(name) {
        let parm = this._parameters[name];
        if (parm) {
            return parm.value;
        }
        return null;
    }
    onDestroy() {
        if (this._controller) {
            this._controller._removeReference();
            this._controller = null;
        }
        for (var i = 0, n = this._controllerLayers.length; i < n; i++)
            this._controllerLayers[i].destroy();
        this._controllerLayers.length = 0;
        this._isPlaying = false;
        this._parameters = null;
    }
}
